
import Utils from '~/assets/utils.js'

export default {
  data () {
    return {
      hero: 'images/resume/resume_screenshot_blur.jpg'
    }
  },
  async asyncData({query}) {
    return { 

    }
  },
  methods: {
    // Random color generation from here: http://blog.adamcole.ca/2011/11/simple-javascript-rainbow-color.html
    getRandColor () {
      return Utils.getRandColor();
    },
    getBW (v) {
      v = v * 0.65 + 0.35;
      return Utils.bwStop(v);
    },
    prettifyDate(date) {
      return Utils.prettifyDate2(date);
    } 
  },
  computed: {
    denseTimeline () {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
}
